import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  themeButton: any;
  darkTheme = 'dark-theme';
  iconTheme = 'uil-sun';
  selectedTheme = localStorage.getItem('selected-theme');
  selectedIcon = localStorage.getItem('selected-icon');

  getCurrentTheme = () => {
    return document.body.classList.contains(this.darkTheme) ? 'dark' : 'light'
  }

  getCurrentIcon = () => {
    return this.themeButton.classList.contains(this.iconTheme) ? 'uil-moon' : 'uil-sun'
  }

  toggleNav: Boolean = false;

  ngOnInit(): void {
    setTimeout(() => {
      this.themeButton = document.getElementById('theme-button');
      if (this.selectedTheme) {
        document.body.classList[this.selectedTheme === 'dark' ? 'add' : 'remove'](this.darkTheme)
        this.themeButton.classList[this.selectedIcon === 'uil-moon' ? 'add' : 'remove'](this.iconTheme)
      }
    }, 1)
  }

  onClickNavToggle() {
    this.toggleNav = !this.toggleNav;
  }

  onClickItem() {
    this.toggleNav = false;
  }

  onClickChangeTheme() {
    document.body.classList.toggle(this.darkTheme)
    this.themeButton.classList.toggle(this.iconTheme);
    localStorage.setItem('selected-theme', this.getCurrentTheme());
    localStorage.setItem('selected-icon', this.getCurrentIcon());
  }
}
